/** Validate the public Shopify response before using any product fields. */
function parseContactProduct(value, expectedHandle) {
  if (
    value === null ||
    typeof value !== "object" ||
    Array.isArray(value) ||
    !Number.isSafeInteger(value.id) ||
    value.id <= 0 ||
    typeof value.title !== "string" ||
    !value.title.trim() ||
    value.title.length > 1000 ||
    typeof value.handle !== "string" ||
    value.handle !== expectedHandle
  )
    throw new Error("Invalid contact product");
  return { title: value.title, handle: value.handle };
}

async function initializeContactProduct() {
  const panel = document.querySelector("[data-contact-product]");
  if (!panel) return;
  const url = new URL(window.location.href);
  const handle = url.searchParams.get("product");
  if (typeof handle !== "string" || !/^[a-z0-9][a-z0-9-]{0,254}$/.test(handle)) return;
  const link = panel.querySelector("[data-contact-product-link]");
  const titleInput = panel.querySelector("[data-contact-product-title]");
  const urlInput = panel.querySelector("[data-contact-product-url]");
  const remove = panel.querySelector("[data-contact-product-remove]");
  if (!link || !titleInput || !urlInput || !remove) return;
  try {
    const response = await fetch(`/products/${encodeURIComponent(handle)}.js`);
    if (!response.ok) return;
    const product = parseContactProduct(await response.json(), handle);
    const productUrl = new URL(`/products/${product.handle}`, window.location.origin);
    link.textContent = product.title;
    link.href = productUrl.href;
    titleInput.value = product.title;
    urlInput.value = productUrl.href;
    titleInput.disabled = false;
    urlInput.disabled = false;
    remove.addEventListener("click", () => {
      titleInput.disabled = true;
      urlInput.disabled = true;
      titleInput.value = "";
      urlInput.value = "";
      panel.hidden = true;
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.delete("product");
      history.replaceState(history.state, "", currentUrl.href);
      panel.closest("form")?.querySelector('input[name="contact[name]"]')?.focus({ preventScroll: true });
    });
    panel.hidden = false;
  } catch {
    // Keep the general contact form usable if the product cannot be loaded.
  }
}
initializeContactProduct();
